<template>
    <div class="card" v-if="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-4">
                    <h3 class="mb-0 text-uppercase">
                        {{ $t('common.grades') }}
                        <!--
                        <base-button type="link" size="sm" class="ml-3"
                            @click="sessionFeatures.openSessions(registrationId)"
                        >
                            {{ $t('common.sessions') }}
                        </base-button>
                        -->
                    </h3>
                </div>
                <div class="col-8 text-right pr-0">

                    <base-button type="secondary" size="sm" @click="clearFilters" v-if="hasFilters">
                        {{ $t('common.clear-filters') }}
                    </base-button>

                    <base-button type="primary" size="sm" @click="openFilters()">
                        {{ $t('common.more-filters') }}
                    </base-button>

                    <actions-dropdown :actions="actions()">
                    </actions-dropdown>
                </div>
            </div>
        </div>

        <div class="pt-2">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search" ref="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows"
                    @sort-change="sortChange"
                    @filter-change="tableFiltersChange"
                    ref="table">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle" @click.prevent="filterByLearner(row.learner)"
                            v-if="sessionFeatures.canUseAllFilters()"
                        >
                            <img :src="row.learner.avatar">
                        </a>
                        <span class="avatar rounded-circle" v-else>
                            <img :src="row.learner.avatar">
                        </span>
                    </template>
                </el-table-column>

                <el-table-column class-name="learners" :label="$t('common.learner')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="filterByLearner(row.learner)"
                                v-if="sessionFeatures.canUseAllFilters()"
                            >
                                {{row.learner.name}}
                            </a>
                            <span v-else>
                                {{row.learner.name}}
                            </span>
                        </h4>
                        <small v-if="row.learner_owner_name">
                            {{ row.learner_owner_name }}
                        </small>
                        <small v-if="row.learner_entity_name">
                            / {{ row.learner_entity_name }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.purpose')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <small>{{ $t('common.cohort') }}:</small>
                            <a href="#" @click.prevent="filterByCohort(row.cohort)"
                                v-if="sessionFeatures.canUseAllFilters()"
                            >
                                {{ row.cohort.name }}
                            </a>
                            <span v-else>
                                {{ row.cohort.name }}
                            </span>
                        </h4>
                        <h4 class="mb-0">
                            <small>{{ $t('common.degree') }}:</small>
                            <a href="#" @click.prevent="filterByDegree(row.degree)">
                                {{ row.degree.name }}
                            </a>
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.status')" width="100"
                    column-key="status"
                    :filters="filtering.unsortedFilteringValues(statusData)"
                    :filtered-value="filters.status"
                    filter-placement="bottom-end"
                >
                    <template v-slot="{row}">
                        <badge :type="statusColor(row.status)">{{ statusLabel(row.status) }}</badge>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.sessions')">
                    <template v-slot="{row}">
                        <a href="#" @click.prevent="openSessions(row)">
                            <small>
                                {{ $t('common.sessions-n', { n: row.sessions_count }) }}
                            </small>
                        </a>
                    </template>
                </el-table-column>

                <el-table-column class-name="result last-column gradecell" label="Pos 1"
                    sortable="custom"
                    prop="position1_grade"
                    width="110"
                    align="left"
                >
                    <template v-slot="{row}">

                        <badge size="md" :type="gonogoColor(row.position1_gonogo)"
                            v-if="row.position1_gonogo !== null"
                        >
                            {{ row.degree.simulation_role_1_name.en }}:
                            {{ row.position1_grade }}
                        </badge>

                    </template>
                </el-table-column>

                <el-table-column class-name="result last-column gradecell" label="Pos 2"
                    sortable="custom"
                    prop="position2_grade"
                    width="110"
                    align="left"
                >
                    <template v-slot="{row}">

                        <badge size="md" :type="gonogoColor(row.position2_gonogo)"
                            v-if="row.position2_gonogo !== null"
                        >
                            {{ row.degree.simulation_role_2_name.en }}:
                            {{ row.position2_grade }}
                        </badge>

                    </template>
                </el-table-column>

                <el-table-column class-name="result last-column gradecell" label="Final"
                    sortable="custom"
                    prop="final_grade"
                    width="100"
                    align="left"
                >
                    <template v-slot="{row}">

                        <badge size="md" :type="gonogoColor(row.final_gonogo)">
                            {{ row.final_grade }}
                        </badge>

                    </template>
                </el-table-column>

            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <form-modal v-model="ctrl.modals.filters"
                :title="$t('common.filters')"
            >
                <grade-filters
                    :modal="ctrl.modals.filters"
                    :value="filters"
                    @input="globalFiltersChange"
                    :features="gradeFeatures"
                >
                </grade-filters>

            </form-modal>

        </portal>
    </div>
</template>

<script>
    import moment from 'moment'
    import CrudController from '@trax/classes/CrudController'
    import CrudFiltering from '../../../classes/CrudFiltering'
    import GradeFilters from './GradeFilters'
    import SessionFeatures from '../sessions/SessionFeatures'
    import GradeFeatures from './GradeFeatures'

    export default {

        components: {
            GradeFilters
        },

        data() {
            let sessionFeatures = new SessionFeatures(this.$router, this.$auth)
            let gradeFeatures = new GradeFeatures(this.$router, this.$auth)
            let filtering = new CrudFiltering('dashboard_grades')
            let sortDefault = ['-registration_id', 'learner.lastname']
            return {
                loaded: false,
                sessionFeatures,
                gradeFeatures,
                filtering,
                sortDefault,
                ctrl: new CrudController({
                    endpoint: '/socrates/api/front/dashboard/store/grades',
                    mapData: gradeFeatures.mapData,
                    unmapData: gradeFeatures.unmapData,
                    modals: ['filters', 'confirmCreate', 'confirmReset'],
                    paging: {
                        perPage: 10,
                        perPageOptions: [10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: sortDefault,
                        relations: ['learner', 'registration', 'cohort', 'degree'],
                        include: ['status_colors', 'status_data', 'gonogo_select', 'gonogo_colors'],
                        accessors: ['learner_owner_name', 'learner_entity_name'],
                    },
                    callbacks: {
                        listed: this.listed,
                    }
                }),
                statusData: [],
                statusColors: {},
                gonogoSelect: {},
                gonogoColors: {},
                moment: moment,
                search: '',
                filters: {},
            }
        },

        created() {

            this.filtering.init(this)

            this.ctrl.query.filters = this.getFilters()

            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.statusData = resp.data.included.status_data
                this.statusColors = resp.data.included.status_colors
                this.gonogoSelect = resp.data.included.gonogo_select
                this.gonogoColors = resp.data.included.gonogo_colors
            })
        },

        mounted() {
            if (this.filters.simpleSearch) {
                this.$refs.search.setFilter(this.filters.simpleSearch)
            }
        },

        watch: {
            search(val) {
                if (val === '') {
                    delete this.filters.simpleSearch
                } else {
                    this.filters.simpleSearch = val
                }
                this.filters = {...this.filters}    // Clone to force reactivity
                this.reload()
            }
        },

        computed: {

            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            },

            hasFilters() {
                // First, remove null filters.
                Object.keys(this.filters).forEach(key => {
                    if (!this.filters[key]) {
                        delete this.filters[key]
                    }
                })

                if (this.registrationId) {
                    return Object.keys(this.filters).length > 1 || this.ctrl.query.sort.toString() != this.sortDefault.toString()
                } else {
                    return Object.keys(this.filters).length > 0 || this.ctrl.query.sort.toString() != this.sortDefault.toString()
                }
            },

            registrationId() {
                return this.$route.params.registrationId
            },
        },

        methods: {

            actions() {
                return [{
                    label: this.$t('common.export-csv'),
                    handler: this.exportCsv,
                }]
            },

            exportCsv() {
                window.open(this.ctrl.client.endpoint + '/csv?filters=' + encodeURIComponent(JSON.stringify(this.getFilters())))
            },

            sortChange(data) {
                this.filtering.sortChange(data, this.sortDefault)
            },

            tableFiltersChange(data) {
                this.filtering.filterChange(data)
            },

            globalFiltersChange(data) {
                this.filters = { ...this.filters, ...data}
                this.reload()
            },

            filterByLearner(learner) {
                this.filters.learner_id = learner.id
                this.filters = {...this.filters}    // Clone to force reactivity
                this.reload()
            },

            filterByDegree(degree) {
                this.filters.degree_id = degree.id
                this.filters = {...this.filters}    // Clone to force reactivity
                this.reload()
            },

            filterByCohort(cohort) {
                this.filters.cohort_id = cohort.id
                this.filters = {...this.filters}    // Clone to force reactivity
                this.reload()
            },

            clearFilters() {
                if (this.registrationId) {
                    this.filtering.clearFilters({registration_id: this.registrationId}, this.sortDefault)
                } else {
                    this.filtering.clearFilters({}, this.sortDefault)
                }
            },

            listed() {
                this.filtering.saveUiConfig()
            },

            getFilters() {
                let filters = {$and: []}
                
                // Registration.
                if (this.registrationId) {
                    filters.$and.push(
                        {registration_id: this.registrationId}
                    )
                }

                // Status.
                if (this.filters.status) {
                    filters.$and.push(
                        {status: {$in: this.filters.status }}
                    )
                }
                
                // Result.
                if (this.filters.final_gonogo) {
                    filters.$and.push(
                        {final_gonogo: {$in: this.filters.final_gonogo }}
                    )
                }

                // Search.
                if (this.filters.simpleSearch) {
                    filters.$and.push({ simpleSearch: this.filters.simpleSearch})
                }
                
                // Addtional filters.
                if (this.filters.cohort_id) {
                    filters.$and.push(
                        {cohort_id: this.filters.cohort_id}
                    )
                }
                if (this.filters.degree_id) {
                    filters.$and.push(
                        {degree_id: this.filters.degree_id}
                    )
                }
                if (this.filters.learner_id) {
                    filters.$and.push(
                        {learner_id: this.filters.learner_id}
                    )
                }

                if (filters.$and.length == 0) {
                    filters = {}
                }
                return filters
            },

            reload() {
                this.ctrl.filter(
                    this.getFilters()
                )
            },
           
            statusColor(status) {
                return this.statusColors[status]
            },

            statusLabel(status) {
                return this.statusData.find(item => item.id == status).name
            },
           
            gonogoColor(gonogo) {
                return this.gonogoColors[gonogo]
            },

            openFilters() {
                this.ctrl.modals.open('filters').then(filters => {
                    this.reload()
                })
            },

            openSessions(row) {
                this.$router.push({ name: 'dashboard-registration-learner-sessions', params: { 
                    registrationId: row.registration_id,
                    learnerId: row.learner_id
                } })
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.learners,
    .card >>> td.learners {
        padding-left: 1rem;
    }
    .card >>> th.gradecell,
    .card >>> td.gradecell {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
    .card >>> td.result .badge {
        color: white;
        font-size: .7rem;
    }
    .card >>> td.result .badge-success {
        background-color: #1aae6f;
    }
    .card >>> td.result .badge-danger {
        background-color: #f80031;
    }
</style>
